export default function () {
  return {
    isSavingContactForm: false,
  };
}
